module.exports = __webpack_public_path__ + "static/media/house.2f301816.svg";